"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckDropTrailer = function SvgIconTruckDropTrailer(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck drop trailer icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Drop Trailer Icon'), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "null",
    strokeWidth: 0.835,
    d: "M44 8.501v25.972h-8.81c0 3.67-2.98 6.652-6.651 6.652a6.653 6.653 0 01-6.652-6.652h-1.33a6.653 6.653 0 01-13.304 0v-6.804H35.19V8.501H44zM13.904 31.147a3.325 3.325 0 100 6.653 3.332 3.332 0 003.327-3.327 3.328 3.328 0 00-3.327-3.326zm14.635 0a3.325 3.325 0 100 6.653 3.332 3.332 0 003.327-3.327 3.328 3.328 0 00-3.327-3.326zM20.26 19.884v3.252h-6.505v-3.252zm0-6.505v3.252H8.878V13.38zm0-6.504v3.252H4V6.875z"
  }));
};

var _default = SvgIconTruckDropTrailer;
exports.default = _default;